import { useMemo, useState } from "react";
import { ArrowRight } from "lucide-react";
import { services as servicesData } from "../Services";
import { ArrowControls, HOME_WRAP, SectionEyebrow } from "./HomeShared";
import { useAppointment } from "../../context/AppointmentContext";

function getVisible(items, start, count) {
  return Array.from({ length: Math.min(count, items.length) }, (_, index) => items[(start + index) % items.length]);
}

export default function ServicesPreview() {
  const [start, setStart] = useState(0);
  const { openAppointment } = useAppointment();
  const visibleServices = useMemo(() => getVisible(servicesData, start, 3), [start]);

  return (
    <section className={`${HOME_WRAP} py-8`}>
      <div className="flex items-end justify-between gap-6">
        <div>
          <SectionEyebrow>What We Do</SectionEyebrow>
          <h2 className="text-[34px] font-bold leading-tight text-[#071746] md:text-[44px]">
            A Full Spectrum of Care for Your Smile
          </h2>
          <p className="mt-2 text-[17px] text-[#4d5b7c]">Complete dental solutions for healthier smiles and lasting confidence.</p>
        </div>
        <ArrowControls
          label="services"
          onPrev={() => setStart((current) => (current - 1 + servicesData.length) % servicesData.length)}
          onNext={() => setStart((current) => (current + 1) % servicesData.length)}
        />
      </div>
      <div className="mt-9 grid gap-6 lg:grid-cols-3">
        {visibleServices.map((service) => {
          const Icon = service.icon;
          return (
            <article key={service.key} className="overflow-hidden rounded-[12px] border border-[#c7cbd3] bg-white">
              <div className="h-[190px] overflow-hidden">
                <img src={service.img} alt="" className="h-full w-full object-cover object-center" />
              </div>
              <div className="relative p-5 pt-10">
                <span className="absolute -top-8 left-6 grid h-16 w-16 place-items-center rounded-full border-[5px] border-white bg-[#06386f] text-white">
                  <Icon className="h-7 w-7" />
                </span>
                <h3 className="text-[22px] font-semibold text-[#071746]">{service.title}</h3>
                <p className="mt-3 min-h-[52px] text-[14px] leading-relaxed text-[#4d5b7c]">{service.desc}</p>
                <button
                  type="button"
                  onClick={openAppointment}
                  className="mt-3 inline-flex items-center gap-2 text-[14px] font-semibold text-[#0052ff] transition hover:text-[#003ec2]"
                >
                  Book Now <ArrowRight className="h-4 w-4" />
                </button>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
